import type { ReactNode } from 'react';
import React from 'react';
import { StyledAnchor } from './StyledComponents';
import type { AtomicEventsAttributes } from '@/lib/atomics';

interface LinkProps {
  fontSize?: string;
  href?: string;
  lineHeight?: string;
  margin?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  testId?: string;
  text?: string | ReactNode;
  atomicEventsAttributes?: AtomicEventsAttributes;
}

export const Link = ({
  fontSize,
  href,
  lineHeight,
  margin,
  onClick,
  testId,
  text,
  atomicEventsAttributes,
}: LinkProps): React.ReactElement => {
  return (
    <StyledAnchor
      data-testid={testId}
      fontSize={fontSize}
      href={href}
      lineHeight={lineHeight}
      margin={margin}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
      data-atomic-wait-intent={atomicEventsAttributes?.intent}
      data-atomic-wait-domain={atomicEventsAttributes?.domain}
      data-atomic-wait-task={atomicEventsAttributes?.task}
      data-atomic-wait-viewname={atomicEventsAttributes?.viewName}
      data-atomic-wait-flow={atomicEventsAttributes?.flow}
    >
      {text}
    </StyledAnchor>
  );
};
